//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class AccessAgentService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[AccessAgent.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/access-agent/list', params || { });
	};

	//GeneratorFlag:[AccessAgent.MyList]
	async myList(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/access-agent/my-list', {'params':params});
	};

	//GeneratorFlag:[AccessAgent.Save]
	async save(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/access-agent/save', params || { });
	};

//GeneratorFlag:[NewAction]
}